import * as constants from './thunkActionConstants';

export function actionPending(actionType, stateType, stateStatus) {
  return actionType === stateType && stateStatus === constants.ACTION_STATUS_PENDING;
}

export function actionSuccess(actionType, stateType, stateStatus) {
  return actionType === stateType && stateStatus === constants.ACTION_STATUS_SUCCESS;
}

export function actionFail(actionType, stateType, stateStatus) {
  return actionType === stateType && stateStatus === constants.ACTION_STATUS_FAIL;
}



// WEBPACK FOOTER //
// ./src/utils/redux/thunkActionHelpers.js